import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import { FaTimes } from "react-icons/fa";
import successimg from "../../../assets/images/successimg.png";

import { Button } from "@material-ui/core";
import { useState } from "react";
import DatePicker from "react-datepicker";

const CommonPopup = ({ open, toggleFilterPopup, getWebsiteVisitCount }) => {
  const [startDate, setStartDate] = useState(new Date());
  const [endDate, setEndDate] = useState(new Date());
  const start = (date) => {
    setStartDate(date);
  };
  const end = (date) => {
    setEndDate(date);
  };
  return (
    <Dialog
      id="dialogBoxRemove"
      className="dialog-stylee"
      open={open}
      onClose={toggleFilterPopup}
    >
      <DialogTitle>
        <div className="row">
          <div className="col-1 text-right ml-auto">
            <FaTimes
              onClick={(event) => {
                event.stopPropagation();
                toggleFilterPopup();
              }}
              className="crossview cp"
            />
          </div>
        </div>
      </DialogTitle>
      <DialogContent>
        <div className="clear10"></div>
        <div className="row height-300">
          <div className="col-12 text-center">
            <img
              src={successimg}
              alt="success"
              className="successimg-new"
            ></img>
            <p className="fs-20 semi-bold text-center">Custom Filter</p>
            <div className="clear10"></div>
          </div>
          <div className="d-flex-align-cent column-gap-10 filter-container">
            <div className="filter-elements">
              <p className="mg-bottom-5">Select Start</p>
              <DatePicker
                className={`form-control instn fs-16 regular w-100 olnone share-popup-input fmlabel dateStyle cp`}
                onChange={(date) => start(date)}
                selected={startDate}
                name="eventDate"
                dateFormat="MM/dd/yyyy"
                maxDate={new Date()}
              />
            </div>
            <div className="filter-elements">
              <p className="mg-bottom-5">Select End</p>
              <DatePicker
                className={`form-control instn fs-16 regular w-100 olnone share-popup-input fmlabel dateStyle cp`}
                onChange={(date) => end(date)}
                selected={endDate}
                name="eventDate"
                dateFormat="MM/dd/yyyy"
                maxDate={new Date()}
              />
            </div>
          </div>
        </div>
        <Button
          variant="contained"
          color="primary"
          className="mg-top-20"
          onClick={() => {
            getWebsiteVisitCount(startDate, endDate);
          }}
        >
          Apply
        </Button>

        <div className="clear10"></div>

        <div className="clear10"></div>
      </DialogContent>
    </Dialog>
  );
};

export default CommonPopup;
